import React from 'react'
import loadingGif from './loading2.gif'
import './styles.css'


export default () => {

	return(
    <fb className="loadingBarMain">
      <div className='loadingGif' style={{backgroundImage: 'url('+loadingGif+')' }}>
      </div>
    </fb>
	)
}



// WEBPACK FOOTER //
// ./src/components/loadingBar/index.js